import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FiLogIn, FiMail, FiLock, FiUser } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
// import logo from '../../assets/logo-compressed.png';

import { logo, eventName } from '../../config';
import { Container, Content, Background, AnimatedDiv2 } from './styles';
import Input from '../../components/Forms/Input';
import Button from '../../components/Forms/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import Logo from '../../components/Logo';
import Whatsapp from '../../components/Whatsapp';
import { useLanguage } from '../../hooks/Language';

interface SignInData {
  email: string;
  password: string;
  name: string;
}

const SignIn: React.FC = () => {
  const history = useHistory();
  const [withPassword, setWithPassword] = useState(false);
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);

  const {translate} = useLanguage();

  const handleSubmit = useCallback(
    async (data: SignInData) => {
      try {
        formRef.current?.setErrors({});

        const shape = withPassword
          ? {
              email: Yup.string()
                .required(`${translate('Email')} ${translate('obrigatório')}`)
                .email(`${translate('Email')} ${translate('obrigatório')}`)
            }
          : {
              email: Yup.string()
                .required(`${translate('Email')} ${translate('obrigatório')}`)
                .email(`${translate('Email')} ${translate('obrigatório')}`),
            };

        const schema = Yup.object().shape(shape);

        await schema.validate(data, { abortEarly: false });

        const { email, name, password } = data;

        await signIn({ email, password, name });
        window.location.href = '/dashboard';
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: translate('Erro na autenticação'),
          description: translate('Email ou senha inválidos'),
        });
      }
    },
    [signIn, addToast, history],
  );

  return (
    <Container>
      <Content>
        <AnimatedDiv2>
       <div style={{padding:'20px', background:'#fff', borderRadius:'10px'}}><img src={logo} alt="Login" /></div> 
          <Form ref={formRef} onSubmit={handleSubmit}>
          <h1 className="">{translate('ACESSAR')}</h1>
                    <Input icon={FiMail} name="email" placeholder={translate('E-mail')} />
              
                    <div style={{display:'flex', width: '100%',flexDirection:'column', alignItems:'center' }}>
                    <Button type="submit">{translate('Entrar')}</Button>
                   
                    <Whatsapp
                text={`${translate('Olá, estou no')} ${eventName}`}
                message={translate('Suporte Técnico')}
              />
       </div>
          </Form>
        </AnimatedDiv2>
      </Content>
    </Container>
  );
};
export default SignIn;
